import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "LY_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#LY_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 18h32v6H0v-6z", fill: "#55BA07" }), /* @__PURE__ */ e.createElement("path", { d: "M0 6h32v12H0V6z", fill: "#1D1D1D" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v6H0V0z", fill: "#E11C1B" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.797 15.066c-1.793-.37-2.257-1.308-2.238-2.754 0-1.53.806-3.08 2.22-3.25 1.413-.169 2.57.359 3.178 1.095-.508-1.998-2.19-2.216-3.48-2.216-1.944-.017-3.938 1.46-3.938 4.238 0 2.42 1.757 4.24 3.994 4.286 2.795 0 3.233-1.93 3.313-2.588-.161.115-.312.254-.466.396-.562.518-1.177 1.084-2.583.793zm4.465-3.774l-1.324.417 1.483.58-.206 1.554 1.004-1.07 1.458.3-.985-1.151.872-1.177-1.218.257-.86-.972-.224 1.262z",
      fill: "#fff"
    }
  ))
), a = t;
export {
  a as default
};
